import { render, staticRenderFns } from "./WorkFlowGraphEditorPopup.vue?vue&type=template&id=670d38d2&scoped=true"
import script from "./WorkFlowGraphEditorPopup.vue?vue&type=script&lang=js"
export * from "./WorkFlowGraphEditorPopup.vue?vue&type=script&lang=js"
import style0 from "./WorkFlowGraphEditorPopup.vue?vue&type=style&index=0&id=670d38d2&prod&lang=scss"
import style1 from "./WorkFlowGraphEditorPopup.vue?vue&type=style&index=1&id=670d38d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d38d2",
  null
  
)

export default component.exports